import { createSlice } from '@reduxjs/toolkit'

import { getCostObjectsAPI } from '@/api/customerApi'

export const NAME = 'cost-objects'
// @ts-ignore
export const fetchCostObjects = customerId => async (dispatch, getState) => {
  const isPending = getIsPending(getState())

  if (isPending) return

  dispatch(loadPending(customerId))

  try {
    const result = await getCostObjectsAPI(customerId)

    dispatch(loadSuccess(result))
  } catch (error) {
    dispatch(loadFailure('Could not load cost objects'))
  }
}

const initialState = {
  isDataPending: false,
  isDataLoaded: false,
  error: undefined,
  costObjects: [],
  customerId: undefined,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loadPending: (state, { payload: customerId }) => {
      state.error = undefined
      state.isDataPending = true
      state.customerId = customerId
    },
    loadSuccess: (state, { payload: costObjects }) => {
      state.isDataPending = false
      state.isDataLoaded = true
      state.costObjects = costObjects
    },
    loadFailure: (state, { payload: error }) => {
      // @ts-ignore
      state.pending = false
      state.isDataLoaded = true
      state.error = error
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { loadPending, loadSuccess, loadFailure, reset } = actions

export default reducer

const getState = (state: any) => state[NAME]

export const getIsPending = (state: any) => getState(state).isDataPending
export const getError = (state: any) => getState(state).error
// @ts-ignore
export const getIsDataLoaded = (state, customerId) =>
  getState(state).isDataLoaded && getCustomerId(state) === customerId

export const getCostObjects = (state: any) => getState(state).costObjects
export const getCustomerId = (state: any) => getState(state).customerId
